import { RegistryWidgetsType } from '@rjsf/utils';
import {
  DatePickerWidget,
  TextAreaWidget,
  TextInputWidget,
  CheckboxWidget,
  DropdownWidget,
  TextWidget,
} from '../katal/widgets/';

/**
 * Generates the list of widgets to be used for Katal Theming of ReactJsonSchema
 * @returns RegistryWidgetsType
 */
export function generateWidgets(): RegistryWidgetsType {
  return {
    KatalDatePickerWidget: DatePickerWidget,
    KatalTextAreaWidget: TextAreaWidget,
    KatalTextInputWidget: TextInputWidget,
    KatalCheckboxWidget: CheckboxWidget,
    KatalDropdownWidget: DropdownWidget,
    KatalTextWidget: TextWidget,
  };
}
